<template>
  <div>
    <title-edit header="Resource center" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" >
        <v-app class="switch-app">
          <v-switch label="Publish" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title TH*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_th" @update="updateTitleTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title EN*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_en" @update="updateTitleEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description TH*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.description_th" @update="updateDescriptionTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description EN*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.description_en" @update="updateDescriptionEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Attached website</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.attached_website" @update="updateAttachedWebsite"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slug Url</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.slug_url" @update="updateSlugUrl"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slide Image :</label>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col v-for="(image, index) in form.slide_images" :key="index" cols="4">
            <v-card @click="removeSlideImage(index)">
              <v-img
                :src="image.image_full_path"
                title="click for remove image"
                width="300px"
                height="150px"
              />
            </v-card>
          </v-col>
        </v-row>
        <input-image-upload
          id="image"
          menu="resource_center"
          @update="updateSlideImage"
          width="140px"
          height="140px"
        />
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteResourceCenter"/>
<!--      <preview-button />-->
      <save-button @click.native="saveResourceCenter"/>
    </div>
  </div>
</template>

<script>
    import TitleEdit from "../../components/TitleHeader/TitleEdit";
    import LineHr from "../../components/Icon/line-hr";
    import SelectOption from "../../components/Input/selectOption";
    import InputTextField from "../../components/Input/InputTextField";
    import DeleteButton from "../../components/Button/DeleteButton";
    import PreviewButton from "../../components/Button/PreviewButton";
    import SaveButton from "../../components/Button/SaveButton";
    import InputEditor from "../../components/Input/InputEditor";
    import InputImageUpload from "../../components/Input/InputImageUpload";
    import {mapState} from "vuex";
    import DatePicker from "../../components/Input/DatePicker";
    export default {
        name: "ResourceCenterEdit",
      components: {
        DatePicker,
        InputImageUpload,
        InputEditor,
        SaveButton,
        PreviewButton, DeleteButton, InputTextField,
        SelectOption, LineHr, TitleEdit},
      computed: {
        ...mapState({
          form: state => {
            return state.ResourceCenter.form;
          }
        })
      },
      data(){
        return{
          optionBranch : [],
        }
      },
      created() {
          this.getBranchData();
      },
      methods:{
        getBranchData() {
          this.$store.dispatch("Branch/getBranchAll").then(res => {
            this.optionBranch = [
              { text: "Select", value: "" },
              ...res.map(type => ({
                value: type.branch_id,
                text: type.branch_name_th + " (" + type.branch_name_en + ")"
              }))
            ];
          });
        },
        saveResourceCenter(){
          this.$store
            .dispatch("ResourceCenter/saveResourceCenter", {
              id: this.form.id,
              data: this.form
            })
            .then(res => {
              alert(res.response_msg);
              if (res.response_code == 200) {
                this.goToResourceCenterTable();
              }
            })
            .catch(() => {
              alert("cannot save Resource center data!");
            });
        },
        deleteResourceCenter(){
          this.$store
            .dispatch("ResourceCenter/deleteResourceCenter", this.form.id)
            .then(res => {
              alert(res.response_msg);
              if (res.response_code == 200) {
                this.goToResourceCenterTable();
              }
            })
            .catch(() => {
              alert("cannot delete Resource center ");
            });
        },
        removeSlideImage(index){
          this.$store.dispatch("ResourceCenter/removeSlideImage", index);
        },
        updateSlideImage(val){
          let image_full_path = val.fullImagePath;
          let slide_image = val.imagePath;
          let data = {
            image_full_path,
            slide_image
          };
          this.$store.dispatch("ResourceCenter/insertSlideImage", data);
        },
        goToResourceCenterTable(){
          this.$router.push("/resource-center");
        },
        updateBranch(val){
          this.form.branch_id = val;
        },
        updateTitleTH(val){
          this.form.title_th = val;
        },
        updateTitleEN(val){
          this.form.title_en = val;
        },
        updateDescriptionTH(val){
          this.form.description_th = val;
        },
        updateDescriptionEN(val){
          this.form.description_en = val;
        },
        updateAttachedWebsite(val){
          this.form.attached_website = val;
        },
        updateSlugUrl(val){
          this.form.slug_url = val;
        }
      }
    }
</script>

<style lang="scss" scoped>

</style>
